/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterPSmall = createReactComponent("outline", "letter-p-small", "IconLetterPSmall", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }]]);

export { IconLetterPSmall as default };
//# sourceMappingURL=IconLetterPSmall.mjs.map
